import React, { useEffect, useRef, useState } from "react"
import LazyLoad from "react-lazy-load"
import { useDispatch, useSelector } from "react-redux"
import cx from "classnames"
import _get from "lodash/get"
import _isEmpty from "lodash/isEmpty"
import { isMobile } from "react-device-detect"
import { scroller } from "react-scroll"

import { PRODUCTS_PER_PAGE } from "@/constants/index"
import Filter from "@/components/ProductList/v2/Filter"
//import ProductTile from "@/components/ProductTile/v2"
import ProductTile from "@/components/ProductList/v2/ProductTile"
import Pagination from "@/components/ProductList/v2/ProductListView/Pagination"
import { addToCompareProduct, removeFromCompareProduct } from "@/utils/product"
import StickyNavHeader from "@/components/ProductList/v2/ProductListView/StickyNav/stickyNavHeader"
import PromoBanner from "@/components/PromoBanner/v2/PromoBanner"
import PartsViewer from "@/components/PartsViewer/v1/PartsViewer"
import useSmartCrop from "@/hooks/useSmartCrop"
import useWindowResize from "@/hooks/useWindowResize"
import usePrevious from "@/hooks/usePrevious"
import {
  getAllFilterQueries as getFacetsFromUrl,
  getFavouraties,
  getPriceSortQuery,
  getSortItemBasedOnURL,
  getSwatchCount,
  replaceSearchUrl,
  retainSearchQueryParams,
} from "@/utils/helper"
import {
  getFilterQuery,
  getFlData,
  getSortList,
  handleKeyPress,
  scrollToFirstProduct,
  scrollToProduct,
} from "@/components/Search/v1/ProductsTab/helper"
import ProductTilesLoader from "./ProductTilesLoader"
import { compareState } from "@/store/features/compareSlice"
import {
  selectProductListState,
  getProducts,
} from "@/store/features/productListSlice"
import { selectAuthState } from "@/store/features/authSlice"
import {
  searchState,
  setSearchFilter,
  setSearchKeyword,
} from "@/store/features/searchSlice"
import styles from "@/components/ProductList/v2/ProductListView/index.module.scss"
import sortStyle from "@/components/ProductList/v2/Sort/index.module.scss"
import filterStyle from "@/components/ProductList/v2/Filter/index.module.scss"
import productTileStyles from "@/components/ProductList/v2/ProductTile/index.module.scss"
import { getUserPersona } from "@/utils/helper"

const ProductsTab = ({
  staticTexts = {},
  totalSearchResults = 0,
  count = 0,
  searchKeyword = "",
  onSearch = () => {},
  type = "",
  page = "",
  currencySign = "",
  lwAppName = "",
  query: queryProp = "",
  isLandscape = false,
  promoJson = {},
  presetConfigs = "",
  componentProps: { disableBestSellers = false, isAnnsacksPlp = "" } = {},
  marketParamValues = [],
  isSterling = false,
  sterlingData = [],
  showSterlingButton = false,
  plpBadge = {},
}) => {
  const dispatch = useDispatch()
  const {
    searchDetails = {},
    searchResponse: { data: { fusion: searchFusion = {} } = {} } = {},
  } = useSelector(searchState)
  const {
    data = [],
    total,
    facets = [],
    facetLabels,
    status,
    colors,
    fusion = {},
  } = useSelector(selectProductListState).plp

  const retainedFilters =
    searchDetails.keyword === searchKeyword && searchDetails[type]?.filters
      ? searchDetails[type].filters
      : []
  const compareData = useSelector(compareState)
  const { access_token: accessToken } = useSelector(selectAuthState)
  const productsPerPage = PRODUCTS_PER_PAGE
  const [width] = useWindowResize()
  const initialPartData = {
    productId: "",
    partId: "",
    isShowModal: false,
  }
  const [showFilter, setShowFilter] = useState(width >= 1024 ? true : false)
  const [rowCols, setRowCols] = useState(width < 1024 ? 1 : 3)
  const [sessionId, setSessionId] = useState("")
  const [paginationState, setPaginationState] = useState({
    curRows: 30,
    start: 0,
  })
  const { curRows, start } = paginationState
  const prevRows = usePrevious(curRows)
  const [scrollToSku, setScrollToSku] = useState(
    () =>
      new URLSearchParams(window.location.search).get("back") ||
      sessionStorage?.plpScrollSku ||
      ""
  )
  const filterModalWindow = useRef(null)
  const [selectedSort, setSelectedSort] = useState({})
  const [filterQueries, setFilterQueries] = useState(null)
  const [swatchCount, setSwatchCount] = useState(5)
  const [xfLink, setXfLink] = useState("")
  const [promoLayout, setPromoLayout] = useState("one-column")
  const [desktopPromo, setDesktopPromo] = useState(3)
  const [mobilePromo, setMobilePromo] = useState(4)
  const [partData, setPartsData] = useState(initialPartData)
  const smartCrop = useSmartCrop()
  const [fusionQueryId, setFusionQueryId] = useState("")
  const [dataPopulated, setDataPopulated] = useState(false)
  const [dataInitPopulated, setDataInitPopulated] = useState(false)
  const [isFusionLoaded, setIsFusionLoaded] = useState(false)
  const [zeroResults, setZeroResults] = useState(false)
  const localData = isSterling && sterlingData.length > 0 ? sterlingData : data
  const [isLoadMore, setIsLoadMore] = useState(false)
  const persona = getUserPersona()
  // const [shownoResultText, setShownoResultText ] = useState(false)

  useEffect(() => {
    const selectedSortItem = getSortItemBasedOnURL(staticTexts, {
      name: "Featured",
    })
    setSelectedSort(selectedSortItem)
  }, [])

  useEffect(() => {
    const handleResize = () => setSwatchCount(getSwatchCount(false))
    window.addEventListener("resize", handleResize)
    const cookie = document?.cookie
    const cookieArray = cookie?.split(";")
    const sessionCookie = cookieArray.filter(item =>
      item?.includes("session#")
    )[0]
    const sessionIdString = sessionCookie?.split("|")[1]
    setSessionId(sessionIdString?.split("#")[1])
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])
  useEffect(() => {
    if (dataInitPopulated && typeof total !== "undefined" && total === 0) {
      setZeroResults(true)
    } else {
      setZeroResults(false)
    }
  }, [dataInitPopulated, total])

  useEffect(() => {
    const search = window.location.search
    if (!_isEmpty(searchFusion) && accessToken && !isFusionLoaded) {
      setIsFusionLoaded(true)
      if (retainedFilters.length > 0) {
        setFilterQueries(retainedFilters)
      } else {
        const filterQuery = getFacetsFromUrl(
          { attributeName: "" }, // this arg to avoid inner condition
          searchFusion,
          marketParamValues
        )
        dispatch(setSearchKeyword(searchKeyword))
        if (!search.includes("tab=")) {
          setFilterQueries(filterQuery)
          dispatch(setSearchFilter({ queries: filterQuery, key: type }))
        } else {
          if (search.includes(`tab=${type}`)) {
            setFilterQueries(filterQuery)
            dispatch(setSearchFilter({ queries: filterQuery, key: type }))
          }
        }
        retainSearchQueryParams(type)
      }
    }
  }, [searchFusion, accessToken])

  useEffect(() => {
    if (accessToken && filterQueries != null) {
      // will trigger from onLoadMore
      if (start) {
        generateListingUrl(isLoadMore, false)
        // Will trigger when user coming back from PDP page
      } else if (start == 0 && scrollToSku) {
        setScrollToSku("")
        generateListingUrl(false, true)
      }
      // When downgrade pagination
      else if (start == 0 && curRows && !!prevRows && prevRows > curRows) {
        generateListingUrl(false, true)
      }
      // will trigger from onRows. And rest of the dependencies
      else if (start == 0 && curRows) {
        generateListingUrl(false, false)
      }
    }
  }, [accessToken, start, curRows, selectedSort, filterQueries, isLoadMore])

  useEffect(() => {
    if (fusion?.fusionQueryId !== undefined) {
      setFusionQueryId(fusion.fusionQueryId)
    }
    if (
      fusion &&
      fusion?.experiment_fragments &&
      fusion?.experiment_fragments !== undefined
    ) {
      setXfLink(fusion?.experiment_fragments[0]?.url_s ?? "")
      setPromoLayout(
        fusion?.experiment_fragments[0]?.promoLayout_s ?? "one-column"
      )
      setDesktopPromo(
        fusion?.experiment_fragments[0]?.promoPlacementDesktop_s ?? 3
      )
      setMobilePromo(
        fusion?.experiment_fragments[0]?.promoPlacementMobile_s ?? 4
      )
    }
  }, [fusion])

  useEffect(() => {
    // To scrollup the product list on back
    if (dataPopulated) return scrollToProduct()
  }, [dataPopulated])

  useEffect(() => {
    switch (true) {
      case width === 1024:
        setRowCols(2)
        break
      case width > 1024:
        setRowCols(3)
        break
      case width < 813:
        setRowCols(2)
        break
      default:
        setRowCols(3)
    }
  }, [isLandscape, width])

  const tileClass = cx({
    "product-listing__tile-col": true,
    "product-listing__tile-col--full-width": !showFilter,
  })

  const filterClass = cx({
    "product-listing__filter": true,
    "product-listing__filter--hide": !showFilter,
    "product-listing__filter--modal": showFilter,
  })

  const sortList = getSortList(staticTexts)
  const sortsCopy = [...sortList]
  sortsCopy.splice(
    sortsCopy.findIndex(a => a.query === `bestSeller_l+asc`),
    1
  )
  const customizedSort = disableBestSellers ? sortsCopy : sortList
  // calculate promo position
  const col =
    width < 768
      ? {
          "one-column": "promo-col-3",
          "two-column": "promo-col-3",
          "three-column": "promo-col-3",
        }
      : width > 768 && width < 1280
      ? {
          "one-column": "promo-col-1",
          "two-column": "promo-col-3",
          "three-column": "promo-col-3",
        }
      : {
          "one-column": "promo-col-1",
          "two-column": "promo-col-2",
          "three-column": "promo-col-3",
        }
  const colVal = { "one-column": 1, "two-column": 2, "three-column": 3 }
  const row = isMobile ? mobilePromo : desktopPromo
  const position =
    isMobile && window.outerWidth < 1024
      ? rowCols === 1
        ? row - 1
        : row * rowCols - 2
      : row * rowCols - colVal[promoLayout]

  const handleSort = item => {
    setPaginationState(state => ({ ...state, start: 0 }))
    setSelectedSort(item)
    replaceSearchUrl("sort", item?.query)
    replaceSearchUrl("tab", type)
    retainSearchQueryParams(type)
    scrollToFirstProduct()
  }

  const handleFilter = queries => {
    setIsLoadMore(false)
    dispatch(setSearchKeyword(searchKeyword))
    dispatch(setSearchFilter({ queries, key: type }))
    setFilterQueries(queries)
    scrollToFirstProduct()
  }

  const generateListingUrl = (
    update,
    enableScroll = true,
    queries = filterQueries ?? []
  ) => {
    const personaTemp = getUserPersona()

    // check this
    const callStart = start
    const fq = getFilterQuery(type, queryProp, queries, personaTemp)
    const fl = getFlData(personaTemp)
    const query = {
      fq,
      rows: curRows,
      start: isLoadMore ? callStart : 0,
    }
    if (selectedSort.name !== staticTexts.Featured) {
      if (selectedSort.query === "price+asc") {
        query.sort = `${getPriceSortQuery()}+asc`
      } else if (selectedSort.query === "price+desc") {
        query.sort = `${getPriceSortQuery()}+desc`
      } else {
        query.sort = selectedSort.query
      }
    }

    const arg = {
      q: searchKeyword,
      fl: fl.join(","),
      ...query,
      profileName:
        type === "Parts"
          ? "profile_service_parts_Search"
          : `profile_${lwAppName.toLowerCase()}_Search`,
      collections: type === "Parts" ? "service_parts" : lwAppName.toLowerCase(),
      displaytype: "search",
      update,
    }
    if (enableScroll) setDataPopulated(false)
    setDataInitPopulated(false)
    dispatch(getProducts({ ...arg }))
      .unwrap()
      .then(obj => {
        setDataInitPopulated(true)
        if (enableScroll) setDataPopulated(true)
      })
      .catch(() => {
        setDataInitPopulated(false)
        if (enableScroll) setDataPopulated(false)
      })
  }

  const handleOnClickPartsDiagramLink = data => {
    const getPartId = ""
    const partId = Array.isArray(getPartId) ? getPartId[0] : getPartId

    setPartsData({
      partId,
      productId: data.ProductProductNo_s,
      isShowModal: true,
    })
  }

  const executeScroll = () => {
    scroller.scrollTo("products-tab", {
      duration: 1500,
      delay: 0,
      smooth: "easeInOutQuart",
    })
  }

  // Will trigger when pagination changes
  const onRows = rows => {
    setPaginationState({ start: 0, curRows: rows })
  }

  // Will trigger on load more clicks
  const onLoadMore = () => {
    setIsLoadMore(true)
    setPaginationState(state => ({ ...state, start: start + curRows }))
  }

  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    document.getElementById(`kf-product-list-tile-details-0`)?.focus()
  }

  const onCloseModal = () => {
    setPartsData({
      ...initialPartData,
      isShowModal: false,
    })
  }
  const { productId = "", partId = "", isShowModal = false } = partData
  let promoIndex = 0
  return (
    <div
      className={`${styles.productListWrapper} ${productTileStyles.productTileWrapper} ${sortStyle.productListingSearchWrapper} ${filterStyle.productListingFilterWrapper}`}
    >
      <div className="product-listing">
        <StickyNavHeader
          showFilter={showFilter}
          rowCols={rowCols}
          setShowFilter={setShowFilter}
          setRowCols={setRowCols}
          staticTexts={staticTexts}
          sorts={customizedSort}
          selectedSort={selectedSort}
          handleSort={handleSort}
          totalResults={totalSearchResults}
          searchKeyword={searchKeyword}
          onSearch={onSearch}
          type={type}
          page={page}
          isSearchTab={true}
        />
        {/* product-list */}
        <div className="container kf-react-plp-container product-listing__tiles">
          <div className="product-listing__row d-block">
            <div className="filter-col">
              {
                <div className={filterClass} aria-modal ref={filterModalWindow}>
                  <div
                    className={`product-listing__filter--sticky`}
                    aria-hidden={!showFilter}
                    onKeyDown={e =>
                      handleKeyPress(e, width, filterModalWindow, setShowFilter)
                    }
                  >
                    {facets && (
                      <Filter
                        tabIndex="0"
                        page={page}
                        texts={staticTexts}
                        currencySign={currencySign}
                        facetData={facets}
                        facetLabels={facetLabels}
                        currFilters={filterQueries}
                        sort={customizedSort}
                        selectedSort={selectedSort}
                        onSortChange={handleSort}
                        selectedFilterCount={
                          filterQueries &&
                          filterQueries.reduce((acc, item) => {
                            return acc + item.value.length
                          }, 0)
                        }
                        onFilter={handleFilter}
                        close={setShowFilter}
                        colors={colors}
                        displayShare={true}
                        displayPrint={true}
                        handleScroll={executeScroll}
                        showFilter={showFilter}
                        totalResults={total}
                        showSort={width <= 991}
                        type={type || "products"}
                        isAnnsacksPlp={isAnnsacksPlp}
                        addToUrl
                      />
                    )}
                  </div>
                </div>
              }
              <div className={tileClass}>
                {localData.length === 0 ? (
                  count === 0 || zeroResults ? (
                    <div
                      className="product-list__no-results"
                      dangerouslySetInnerHTML={{
                        __html: staticTexts.searchNoResultErrorMessage,
                      }}
                    ></div>
                  ) : (
                    <ProductTilesLoader rowCols={rowCols} />
                  )
                ) : (
                  <>
                    <div className={`product-listing__row row-cols-${rowCols}`}>
                      {localData.map((product, i) => {
                        const positionRemainder = (i + 1) % position
                        return (
                          <React.Fragment
                            key={`${i}-${product.Product_Category}-${product.ctId_s}`}
                          >
                            <div
                              className="product-listing__tile"
                              key={`${i}-${product.Product_Category}-${product.ctId_s}`}
                              id={product["masterSKU_s"]}
                            >
                              <LazyLoad className="kf-lazyload-wrapper">
                                <ProductTile
                                  loading={status !== "succeeded"}
                                  data={product}
                                  texts={staticTexts}
                                  category={product["Product_Category"]
                                    ?.replace(/\s/g, "-")
                                    .toLowerCase()}
                                  lite={!isLandscape ? rowCols === 2 : false}
                                  addToCompare={addToCompareProduct}
                                  removeFromCompare={removeFromCompareProduct}
                                  compareData={compareData}
                                  highlightText={searchKeyword}
                                  currencySign={currencySign}
                                  mapImageToColor
                                  currFilters={filterQueries}
                                  index={i}
                                  swatchCount={swatchCount}
                                  favorites={getFavouraties()?.lineItems}
                                  type={type}
                                  rowCols={rowCols}
                                  presetConfigs={presetConfigs}
                                  isPartsDiagramLinkVisible={false}
                                  handleOnClickPartsDiagramLink={
                                    handleOnClickPartsDiagramLink
                                  }
                                  fusionQueryId={fusionQueryId}
                                  parent="search"
                                  onRows={onRows}
                                  sessionId={sessionId}
                                  isSterling={isSterling}
                                  sterlingData={sterlingData}
                                  showSterlingButton={showSterlingButton}
                                  plpBadge={plpBadge}
                                  saleInfo={
                                    product[`Sale.${persona}.Details_ss`]
                                  }
                                />
                                {/* <ProductTile
                                    rowCols={rowCols}
                                    tabIndex="0"
                                    loading={status !== "succeeded"}
                                    data={product}
                                    mapImageToColor
                                    texts={staticTexts}
                                    lite={
                                      !isLandscape
                                        ? rowCols === 2
                                          ? true
                                          : false
                                        : false
                                    }
                                    addToCompare={addToCompareProduct}
                                    removeFromCompare={removeFromCompareProduct}
                                    compareData={compareData}
                                    // isEnable={props.isEnable}
                                    // defaultImage={props.defaultImageTag}
                                    // hoverImage={props.hoverImageTag}
                                    currencySign={currencySign}
                                    // isGrouped={isGrouped}
                                    swatchCount={swatchCount}
                                    favorites={getFavouraties()?.lineItems}
                                    currFilters={filterQueries}
                                    plpPage={true}
                                    favPage={false}
                                    index={i}
                                    presetConfigs={presetConfigs}
                                    // categoryData={categoryData}
                                  /> */}
                              </LazyLoad>
                            </div>
                            {xfLink && positionRemainder === 0 && (
                              <div
                                className={`${col[promoLayout]} product-listing__tile`}
                              >
                                <PromoBanner
                                  promoJson={promoJson}
                                  xfLink={xfLink}
                                  col={colVal[promoLayout]}
                                  position={0}
                                  promoIndex={++promoIndex}
                                  smartCrop={smartCrop}
                                  width={width}
                                />
                              </div>
                            )}
                          </React.Fragment>
                        )
                      })}
                    </div>
                    <Pagination
                      displayShare={true}
                      displayPrint={true}
                      totalResults={isSterling ? 1 : total}
                      isSearchTab={true}
                      {...{
                        staticTexts,
                        onLoadMore,
                        curRows,
                        data,
                        productsPerPage,
                        onRows,
                        handleBackToTop,
                        width,
                        page,
                        type,
                      }}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <PartsViewer
        productId={productId}
        partId={partId}
        showModal={isShowModal}
        page={page + " results"}
        onClose={onCloseModal}
      />
    </div>
  )
}

export default ProductsTab
